import { useState, useCallback } from 'react';

/**
 * useContextMenu Hook
 * 
 * Manages context menu state and actions for message interactions.
 * Provides right-click functionality and message options.
 * 
 * @param {Function} handleReplyToMessage - Function to handle reply to message
 * @returns {Object} Context menu utilities
 */
const useContextMenu = (handleReplyToMessage) => {
  // 🎨 CONTEXT MENU: State for context menu
  const [contextMenu, setContextMenu] = useState({
    isVisible: false,
    position: { x: 0, y: 0 },
    message: null
  });

  // 🎨 CONTEXT MENU: Handle context menu actions
  const handleContextMenuAction = useCallback((action, message) => {
    switch (action) {
      case 'reply':
        handleReplyToMessage(message);
        break;
      case 'forward':
        break;
      case 'star':
        break;
      case 'pin':
        break;
      case 'favorite':
        break;
      case 'delete':
        break;
      case 'select':
        break;
      case 'share':
        break;
      case 'react':
        break;
      default:
        // Unknown action
    }
    
    // Close context menu after action
    setContextMenu({
      isVisible: false,
      position: { x: 0, y: 0 },
      message: null
    });
  }, [handleReplyToMessage]);

  // 🎨 CONTEXT MENU: Show context menu
  const showContextMenu = useCallback((e, message) => {
    e.preventDefault();
    setContextMenu({
      isVisible: true,
      position: { x: e.clientX, y: e.clientY },
      message: message
    });
  }, []);

  // 🎨 CONTEXT MENU: Close context menu
  const closeContextMenu = useCallback(() => {
    setContextMenu({
      isVisible: false,
      position: { x: 0, y: 0 },
      message: null
    });
  }, []);

  return {
    contextMenu,
    handleContextMenuAction,
    showContextMenu,
    closeContextMenu
  };
};

export default useContextMenu;
